/* @flow */

import { rem } from 'polished';

import { aaDarkGrey, mediumGrey } from '@e180/ui/lib/token/palette';
import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    color: mediumGrey,

    fontSize: rem(12, baseFontSize),
    fontStyle: 'italic',
    lineHeight: 19 / 12,
    WebkitFontSmoothing: 'antialiased',
  },
  'root-onLightBg': {
    color: aaDarkGrey,

    fontWeight: 600,
  },
};
